import {
  NavTreeDep,
  NavTreeDepSplit,
} from "../../../../../services/navigation/types";
import slugify from "slugify";

export const departmentHasSections = (
  department: NavTreeDep,
  notEmptyCategories: NavTreeDepSplit[],
): boolean => {
  return department.splits.length > 0 && notEmptyCategories.length > 0;
};

// Helper function to determine if department has sections with items
export const getNotEmptyCategories = (
  splits: NavTreeDepSplit[],
): NavTreeDepSplit[] => splits.filter((section) => section.items.length > 0);

// Helper function to split name into two lines based on "&" or space
export const splitDepartmentName = (name: string): [string, string] => {
  const ampIndex = name.indexOf("&");
  const spaceIndex = name.indexOf(" ");
  const shouldSplit = ampIndex >= 0 || (name.length > 10 && spaceIndex >= 0);

  if (!shouldSplit) return [name, ""];

  const splitIndex = ampIndex >= 0 ? ampIndex + 1 : spaceIndex + 1;
  return [
    name.substring(0, splitIndex).trim(),
    name.substring(splitIndex).trim(),
  ];
};

export const sanitizeNavDepartmentName = (path: string, name: string) =>
  slugify(`nav-${path}-${name.toLowerCase()}`);

export const sanitizeSubmenuId = (name: string): string =>
  slugify(`submenu-${name.toLowerCase()}`, { lower: true, strict: true });

/**
 * Keyboard helpers
 */
export const tabKey = (e: KeyboardEvent | React.KeyboardEvent): boolean =>
  e.key === "Tab" || e.code === "Tab";

export const enterKey = (e: KeyboardEvent | React.KeyboardEvent): boolean =>
  e.key === "Enter" || e.code === "Enter";

export const spaceKey = (e: KeyboardEvent | React.KeyboardEvent): boolean =>
  e.key === " " || e.code === "Space";

export const escKey = (e: KeyboardEvent | React.KeyboardEvent): boolean =>
  e.key === "Escape" || e.code === "Escape";
